module.exports = __webpack_public_path__ + "static/media/delete.3032745d.svg";